<template>
  <div class="container-fluid text-center">
    <div class="row">
      <div class="col offset-lg-1 text-left font-weight-bold" v-if="!isMobile()">{{ poster.presentation_code }}
        {{ poster.title }}
      </div>
      <div class="col offset-lg-1 text-left smaller" v-else>{{ poster.presentation_code }} <span
          v-html="poster.title"></span></div>
    </div>
    <div class="row">
      <div class="col col-1 offset-1 d-flex">
        <router-link :to="getBackUrl()" class="mr-auto">
          <button class="btn btn pl-0">
            <icon :icon="['fad', 'arrow-circle-left']"/>
            Back
          </button>
        </router-link>
      </div>
      <div class="col col-8">
        <button class="btn" v-on:click="toggleFullscreen" title="Toggle fullscreen">
          <icon :icon="['fad', 'expand']"/>
          <span v-if="fullscreen === true">Close fullscreen</span>
          <span v-else="fullscreen">Fullscreen</span>
        </button>
        <router-link class="btn" :to="'/viewer/abstract/' + poster.abstract_id" title="Switch to abstract">
          <icon :icon="['fab', 'wpforms']"/>
          Abstract
        </router-link>
        <router-link class="btn" :to="'/viewer/' + poster.abstract_id" title="Switch to presentation">
          <icon :icon="['fad', 'file-pdf']"/>
          Presentation
        </router-link>
        <a class="btn" :href="poster.website" target="_blank"
           v-if="poster.website != null" title="open website">
          <icon :icon="['fad', 'external-link-alt']"/>
          Website(external)
        </a>
      </div>
    </div>
    <div class="row" v-if="poster.content && poster.content.video">
      <div :class="getClasses()">
        <div class="alert alert-info mt-5" v-if="videoCheck=== true && videoPlay === false">
          <div>
            The video leads to an external source.
            This was deposited by the abstract presenter. <br>
            By confirming this note, the video is retrieved from the address<br>
            <a :href="getUrl(poster.content.video)" target="_blank">{{ getUrl(poster.content.video) }}</a>.<br>
            This address receives information about the call. To find out what
            information this page collects, please contact the corresponding page.
            We assume no liability.
          </div>
          <button class="btn btn-primary mt-3" v-on:click="videoPlay = true">I confirm to watch this video</button>
        </div>
        <div v-if="videoCheck === false || (videoCheck=== true && videoPlay === true)">
          <youtube :video-id="getId()" ref="youtube" v-if="poster.content.video.includes('youtu')"></youtube>
          <v-playback :url="getUrl(poster.content.video)" v-else></v-playback>
        </div>
      </div>
    </div>
    <div v-else>
      <loader></loader>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex'
import Loader from "../components/Loader";
import pdfvuer from "pdfvuer";

export default {
  name: "ViewerVideo",
  components: {Loader},
  computed: {
    ...mapGetters({
      poster: 'poster'
    }),
    ...mapState([
      'presentationSite', "fullscreen", "videoCheck"
    ])
  },
  data() {
    return {
      videoPlay: false,
    }
  },
  methods: {
    ...mapActions({
      getPosterById: 'getPosterById',
    }),
    async getPdf() {
      this.$store.commit('setPoster', {});
      this.getPosterById(this.$route.params.id).then((response) => {
        this.$store.commit('setPoster', response.data);
      }).catch((error) => {
      })
    },
    getClasses() {
      let code = 'col col-xl-7 offset-xl-2 col-md-9 offset-md-1 border';
      if (this.$store.state.fullscreen === true) {
        code = 'col col-xl-10 offset-xl-1 col-md-10 offset-md-1 border';
      }
      return code;
    },
    getBackUrl() {
      return '/view/' + this.$route.params.id;
    },
    toggleFullscreen() {
      this.$store.state.fullscreen = !this.$store.state.fullscreen;
    },
    getId() {
      return this.$youtube.getIdFromUrl(this.$store.state.poster.content.video);
    },
    error: function (err) {
    },
    getUrl(url) {
      if (!url && url.startsWith('http')) {
        return url;
      }
      return process.env.VUE_APP_PATH_S3URL + url;
    }
  },
  mounted() {
    this.$store.state.fullscreen = true;
  },
  created() {
    this.$ga.event(process.env.VUE_APP_GOOGLE_ANALYTICS_NAME, 'viewer/video', this.$route.params.id);
    this.getPdf();
  }
}
</script>

<style scoped>

</style>
